'use client'

import React from 'react';
import { useToast } from '@chakra-ui/react'
import HeroSection from './Hero';
import IntroSection from './Intro';
import { GuideSection, PeriodSection } from './Guide';
import NominateSection from './NominateSection';
import CandidatesSection from './CandidatesSection';
import RulesSection from './Rules';

const shareUrl = "https://escape.bar/event/goty2024";
const shareMessage = "第四屆金逃獎盛大展開！快來投票支持你最愛的遊戲！";
const lineShareMessage = `https://line.me/R/share?text=${shareMessage}%0Ahttps%3A%2F%2Fescape.bar%2Fevent%2Fgoty2024%3Futm_source%3DLINE%26utm_medium%3Dsocial%26utm_campaign%3DGOTY2024%26openExternalBrowser%3D1`;

const Goty2024Page = () => {
  return (
    <div className="bg-[#0D6072] overflow-hidden">
      <HeroSection />
      <IntroSection />
      <GuideSection />
      <PeriodSection />
      <CandidatesSection />
      <RulesSection />
    </div>
  )
};

const ShareButtons = () => {
  const toast = useToast()

  const handleFacebookShare = () => {
    window.FB?.ui({
      method: 'share',
      href: `${shareUrl}?utm_source=Facebook&utm_medium=social&utm_campaign=GOTY2024`,
      quote: shareMessage
    });
  };

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast({ title: '已複製網址', position: 'top', status: 'success', duration: 3000 });
    } catch (err) { console.log(err); }
  };

  const handleNativeShare = async () => {
    try {
      await window?.navigator?.share?.({
        title: "2024第四屆年度實境遊戲選拔賽－金逃獎",
        text: shareMessage,
        url: shareUrl,
      });
    } catch (err) { console.log(err); }
  };

  return (
    <div className='flex items-center gap-x-4'>
      <p className='text-lg font-bold text-white tracking-wide'>分享給朋友</p>
      <div className='flex gap-x-4'>
        <button onClick={handleFacebookShare} className="w-9 h-9 bg-transparent bg-no-repeat bg-center border-none cursor-pointer transition-transform duration-200 hover:scale-105 active:scale-105" style={{backgroundImage: 'url(https://storage.googleapis.com/escape-bar.appspot.com/assets/images/share-facebook.svg)'}} />
        <a href={lineShareMessage} target="_blank" rel="noopener noreferrer">
          <button className="w-9 h-9 bg-transparent bg-no-repeat bg-center border-none cursor-pointer transition-transform duration-200 hover:scale-105 active:scale-105" style={{backgroundImage: 'url(https://storage.googleapis.com/escape-bar.appspot.com/assets/images/share-line.svg)'}} />
        </a>
        <button onClick={handleCopyClick} className="w-9 h-9 bg-transparent bg-no-repeat bg-center border-none cursor-pointer transition-transform duration-200 hover:scale-105 active:scale-105" style={{backgroundImage: 'url(https://storage.googleapis.com/escape-bar.appspot.com/assets/images/share-copy.svg)'}} />
        {typeof window !== 'undefined' && window.navigator.share && (
          <button onClick={handleNativeShare} className="w-9 h-9 bg-transparent bg-no-repeat bg-center border-none cursor-pointer transition-transform duration-200 hover:scale-105 active:scale-105" style={{backgroundImage: 'url(https://storage.googleapis.com/escape-bar.appspot.com/assets/images/share-native.svg)'}} />
        )}
      </div>
    </div>
  )
};

export default Goty2024Page;